import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  DataGrid,
  Grid,
  Input,
} from '../../components';
import { buscaDestinatarios } from '../../utils/requests';
import { tipoEntidade } from '../../utils/listsSelect';

const destinoRGPS = '01000';

class Destinacao extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    tipoRegime: null,
    tipoEntidade: null,
    uf: null,
    destinatario: null,
    destinatarioOrigem: null,
    carregamentoExterno: false,
  });

  componentWillMount() {
    if (this.props.destinatarios.length === 0) {
      buscaDestinatarios(this.buscaDestinatariosFail);
    }
  }

  carregarDestinaratio(dest) {
    let objDestinatario = null;
    if (!this.state.tipoEntidade && this.props.requerimento.destinatario) {
      objDestinatario =
        this.props.destinatarios.find(d => d.value === this.props.requerimento.destinatario.codigo);

      this.setState({
        tipoRegime: dest.codigo === '01000' ? 1 : 2,
        tipoEntidade: objDestinatario.tipoRegimeProprio,
        uf: dest.uf,
        destinatario: dest.codigo,
        carregamentoExterno: true,
      });
    }
  }

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    }, () => this.trataFormulario(name));
  }

  // Encaminha para as funcoes que tratam alteracoes em cada campo
  trataFormulario = (campoAlterado) => {
    if (campoAlterado === 'tipoRegime') {
      this.trataTipoRegime();
      this.props.apagaRegraDeCalculo();
    }
    if (campoAlterado === 'tipoEntidade') {
      this.trataTipoEntidade();
    }
    if (campoAlterado === 'uf') {
      this.trataUf();
    }
    if (campoAlterado === 'destinatario') {
      this.trataDestinatario();
    }
  }

  trataUf = () => {
    this.setState(
      {
        destinatario: null,
      },
      () => {
        this.props.handleChange({
          value: null,
          isValid: false,
        }, 'destinatario');
      },
    );
  }

  trataDestinatario = () => {
    this.props.handleChange({
      value: this.state.destinatario,
      isValid: true,
    }, 'destinatario');
    this.props.calcularTempoRO(this.state.destinatario, false);
  }

  trataDestinatarioOrigem = (orgaoCentralizador) => {
    this.props.handleChange({
      value: orgaoCentralizador,
      isValid: true,
    }, 'destinatarioOrigem');
  }

  trataTipoEntidade = () => {
    this.setState(
      {
        destinatario: null,
        uf: null,
      },
      () => {
        this.props.handleChange({
          value: null,
          isValid: false,
        }, 'destinatario');
      },
    );
  }

  trataTipoRegime = () => {
    const tipoEntidadeAposAlteracao = null;
    let destinatarioAposAlteracao = null;
    if (this.state.tipoRegime === 1) {
      destinatarioAposAlteracao = destinoRGPS;
    }
    this.setState(
      {
        tipoEntidade: tipoEntidadeAposAlteracao,
        destinatario: destinatarioAposAlteracao,
      },
      () => {
        this.props.handleChange({
          value: destinatarioAposAlteracao,
          isValid: destinatarioAposAlteracao !== null,
        }, 'destinatario');
      }, this.props.calcularTempoRO(destinatarioAposAlteracao, false),
    );
  }

  listaFiltradaDestinatarios = () => {
    const listaParticipantes = this.props.destinatarios.filter((item) => {
      if (item.tipoRegimeProprio === this.state.tipoEntidade &&
        ((item.uf && this.state.tipoEntidade === 2) ? item.uf === this.state.uf : true)) {
        return item;
      }
      return null;
    });
    return listaParticipantes;
  }

  carregaUfDosMunicipios = () => {
    const listaUf = [];
    this.props.destinatarios.forEach((item) => {
      if (item.uf && !listaUf.find(itemLista => itemLista.value === item.uf)) {
        listaUf.push({
          label: item.uf,
          value: item.uf,
        });
      }
    });
    listaUf.sort((a, b) => {
      if (a.value > b.value) {
        return 1;
      }
      if (a.value < b.value) {
        return -1;
      }
      return 0;
    });
    return listaUf;
  }

  buscaDestinatariosFail = () => {
    this.setState({ tipoRegime: null });
  }

  obterValorEntidade = () => {
    if (this.props.requerimento.destinatario && this.props.requerimento.destinatario.codigo) {
      const objDestinatario =
        this.props.destinatarios.find(d => d.value === this.props.requerimento.destinatario.codigo);
      return objDestinatario.tipoRegimeProprio;
    }

    return this.state.tipoEntidade;
  }

  render() {
    if (!this.state.carregamentoExterno && this.props.destinatarios.length > 0) {
      this.carregarDestinaratio(this.props.requerimento.destinatario);
    }

    let labelAviso;
    if (this.state.tipoEntidade === 1 && this.state.destinatario) {
      const orgao = this.props.destinatarios.find(itemLista =>
        itemLista.value === this.state.destinatario);

      let orgaoCentralizador = '';
      if (orgao.codigoOrgaoCentralizador) {
        orgaoCentralizador = this.props.destinatarios.find(item =>
          item.value === orgao.codigoOrgaoCentralizador);

        labelAviso = `Este requerimento será destinado a ${orgaoCentralizador.label}
        que ${orgao.inOrgaoExtinto ? 'Sucede' : 'Centraliza'} : ${orgao.label}`;
      }
    }

    return (
      <DataGrid title="Destinação" icon="ico-route" >
        { this.props.requerimento.solicitante.codigo === '01000'
          && this.props.tipoRequerimento === 1 && this.props.destinatarios.length > 0 &&
          <React.Fragment>
            <div className="row">
              <Grid cols="12 12 6 6">
                <Input
                  disabled
                  label="Solicitante"
                  value={this.props.requerimento.solicitante.nome}
                />
              </Grid>
            </div>
            <div className="row">
              <Grid cols="4 4 4 4">
                <Input
                  label="Entidade"
                  onChange={e => this.handleChange(e, 'tipoEntidade')}
                  placeholder="Selecione a entidade"
                  value={this.obterValorEntidade()}
                  itemList={tipoEntidade}
                  custom
                  number
                />
              </Grid>
              {this.state.tipoEntidade === 2 ? (
                <Grid cols="4 4 4 4">
                  <Input
                    label="UF"
                    onChange={e => this.handleChange(e, 'uf')}
                    placeholder="Selecione a UF"
                    value={this.state.uf}
                    itemList={this.carregaUfDosMunicipios()}
                    custom
                  />
                </Grid>
              ) : ''}
              <Grid cols="8 8 8 8">
                <Input
                  label="Destinatário"
                  onChange={e => this.handleChange(e, 'destinatario')}
                  placeholder="Selecione o destinatário"
                  value={this.state.destinatario}
                  itemList={this.listaFiltradaDestinatarios()}
                  custom
                />
              </Grid>
            </div>
          </React.Fragment>
        }

        { ((this.props.tipoRequerimento === 2) || (this.props.requerimento.solicitante.codigo !== '01000')) &&
          <div className="row">
            <Grid cols="12 12 6 6">
              <Input
                disabled
                label="Solicitante"
                value={this.props.requerimento.solicitante.nome}
              />
            </Grid>
            <Grid cols="12 12 6 6">
              <Input
                disabled
                label="Destinatário"
                value={this.props.requerimento.destinatario.nome}
              />
            </Grid>
          </div>
        }

        {this.props.requerimento.destinatarioOrigem &&
          <div className="row">
            <Grid cols="12 12 12 12">
              <Input
                disabled
                label="Destinatário Origem"
                value={this.props.requerimento.destinatarioOrigem.nome}
              />
            </Grid>
          </div>
        }

        <div className="row">
          <Grid cols="12 12 12 12" style={{ color: '#27AE60' }}>
            { labelAviso }
          </Grid>
        </div>
      </DataGrid>
    );
  }
}

Destinacao.propTypes = {
  requerimento: PropTypes.objectOf(PropTypes.object).isRequired,
  destinatarios: PropTypes.arrayOf({
    label: PropTypes.string,
    value: PropTypes.number,
    tipoRegimeProprio: PropTypes.number,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  apagaRegraDeCalculo: PropTypes.func.isRequired,
  tipoRequerimento: PropTypes.number.isRequired,
  calcularTempoRO: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({ destinatarios: state.base.destinatarios });

export default connect(mapStateToProps)(Destinacao);



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Destinacao.jsx